import React from "react";
import _ from "underscore";
import { Link } from "react-router-dom";

function LinkBlock(props) {
    return <Link to={props.href} children={props.node.children[0].value} />;
}

export default LinkBlock;